import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import AdvancedSection from "./AdvancedSection";

// p × q genérico. A diferencia de "Por mascota" —que tiene el nombre del atributo
// escrito en el código del motor— aquí el nombre lo pone el admin, así que un
// producto nuevo que cobre por unidad (guardias, empleados, sucursales) se
// configura sin tocar código ni en calculator ni en flow.
export default function PrecioCantidadConfig({ config, onChange }) {
  const atributo = config?.cantidad?.atributo || "";
  const etiquetas = config?.cantidad?.etiquetas || {};

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
        <p className="text-sm text-gray-700">
          Prima = precio unitario del plan (fila de <strong>Precios Base</strong> con <code>plan_id</code> +{" "}
          <code>Activo</code>) × la cantidad que ingresa el cliente. La cantidad es lo único que pide el miniform;
          los datos de cada unidad (RUT, nombre) los pide el plan por sus <strong>módulos requeridos</strong>.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label className="text-xs text-gray-500">Nombre del atributo de cantidad</Label>
          <Input
            value={atributo}
            onChange={(e) => onChange("cantidad.atributo", e.target.value)}
            placeholder="cantidad_guardias"
          />
          <p className="mt-1 text-xs text-gray-500">
            Con este nombre viaja la cantidad al calculator. Si lo dejas vacío se usa <code>cantidad</code>.
          </p>
        </div>
        <div>
          <Label className="text-xs text-gray-500">Máximo por cotización</Label>
          <Input
            type="number"
            min="1"
            value={config?.cantidad?.maximo ?? ""}
            onChange={(e) => onChange("cantidad.maximo", e.target.value === "" ? "" : Number(e.target.value))}
            placeholder="500"
          />
          <p className="mt-1 text-xs text-gray-500">
            Tope de unidades por cotización: un cero de más convierte 10 en 100 y la prima resultante es cobrable.
          </p>
        </div>
      </div>

      <div>
        <Label className="text-xs text-gray-500">Cómo se llama la unidad en el cotizador (opcional)</Label>
        <div className="mt-1 grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            value={etiquetas.singular || ""}
            onChange={(e) => onChange("cantidad.etiquetas.singular", e.target.value)}
            placeholder="guardia (singular)"
          />
          <Input
            value={etiquetas.plural || ""}
            onChange={(e) => onChange("cantidad.etiquetas.plural", e.target.value)}
            placeholder="guardias (plural)"
          />
          <Input
            value={etiquetas.pregunta || ""}
            onChange={(e) => onChange("cantidad.etiquetas.pregunta", e.target.value)}
            placeholder="¿Cuántos guardias quieres asegurar?"
          />
        </div>
        <p className="mt-1 text-xs text-gray-500">
          Si las dejas vacías, flow las deriva del nombre del atributo
          (<code>cantidad_guardias</code> → "guardia" / "guardias").
        </p>
      </div>

      <AdvancedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-gray-500">Precio base — Tabla</Label>
            <Input value={config?.precioBase?.tabla || ""} onChange={(e) => onChange("precioBase.tabla", e.target.value)} placeholder="precios_base" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Precio base — Campo Resultado</Label>
            <Input value={config?.precioBase?.campoResultado || ""} onChange={(e) => onChange("precioBase.campoResultado", e.target.value)} placeholder="precio_uf" />
          </div>
        </div>
      </AdvancedSection>
    </div>
  );
}
